import {
  // faFacebookF,
  // faTwitter,
  // faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

export const iconsData = [
  // { icon: faFacebookF, href: 'https://www.facebook.com/' },
  // { icon: faTwitter, href: 'https://twitter.com/' },
  // { icon: faInstagram, href: 'https://www.instagram.com/' },
  {
    icon: faLinkedin,
    href: 'https://www.linkedin.com/?original_referer=https%3A%2F%2Fwww.google.com%2F',
  },
];
